import React from 'react';
import MultipleTooltip from '../../../../common/components/MultipleTooltip';
import textSuggestionsIcon from '../../../../common/components/ButtonTextSuggestions/Write.svg';
import ModalCommon from '../../../../common/components/ModalCommon';
import {AddEditCustomerForm} from './AddEditCustomerForm';
import {EditCustomerContextProvider, useEditCustomerContext} from './EditCustomerContext';
import styles from './EditCustomerButton.module.scss';
import Spinner from '../../../../common/components/Spinner';

const Modal = () => {
  const {isValid, submitForm, lodaing} = useEditCustomerContext();

  return (
    <ModalCommon
      header={`עריכת לקוח קיים`}
      openButtonLabel={'עריכת לקוח קיים'}
      closeButtonLabel={'סגירה'}
      handleAction={submitForm}
      disableActionButton={!isValid}
      customModalTrigger={(
        <MultipleTooltip
          id={`textSuggestions`}
          customIconClassName={styles.triggerButton}
          label={'עריכת לקוח קיים'}
          icon={textSuggestionsIcon}
        />
      )}
      classNameTriggerContainer={styles.triggerContainer}
    >
      {lodaing
        ? <Spinner/>
        : <AddEditCustomerForm/>}

    </ModalCommon>
  );
};

export const EditCustomerButton = ({customer, shumaID, customerID, onSuccess, onFail}) => {
  return (
    <EditCustomerContextProvider
      customer={customer}
      customerID={customerID}
      shumaID={shumaID}
      onFail={onFail}
      onSuccess={onSuccess}
    >
      <Modal/>
    </EditCustomerContextProvider>
  );
};